import { IProjectTransactionRelatedAgent } from './project-transaction-related-agent.interface';
import { IProjectTransactionRelatedCobroke } from './project-transaction-related-cobroke.interface';
export interface IProjectTransactionRelatedParty {
  mains: IProjectTransactionRelatedAgent[];
  main: IProjectTransactionRelatedAgent;
  leaders: IProjectTransactionRelatedAgent[];
  internals: IProjectTransactionRelatedAgent[];
  externals: IProjectTransactionRelatedCobroke[];
}
